import F84Game from "../../Game";

export default class Strings {
    private static _json: any = null;

    static get(id: string): string {
        if (this._json == null) {
            this._json = F84Game.Instance.cache.json.get("strings");
        }
        if (this._json[id] === undefined) {
            return "MISSING";
        }
        return this._json[id][F84Game.Instance.locale];
    }

    static has(id: string): boolean {
        if (this._json == null) {
            this._json = F84Game.Instance.cache.json.get("strings");
        }
        if (this._json[id] === undefined) {
            return false;
        }
        return true;
    }
}
